<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="entity-info">
  <h3>
    <span class="LayerLine1">Entity:</span>
    <span class="LayerData1">{{retainEarningsObj.entityName + " : " + retainEarningsObj.taxYearBegin + " - " + retainEarningsObj.taxYearEnd}}</span>
  </h3>
  <h3>
    <span class="LayerLine1">Business:</span>
    <span class="LayerData1">{{retainEarningsObj.meCode + " - " + retainEarningsObj.meName}}</span>
  </h3>
  <h3>
    <span class="LayerLine1">Tax Code:</span>
    <span class="LayerData1">{{retainEarningsObj.taxCode}}</span>
  </h3>
  @if (globalScenarioDesc === 'Qualified Amended Returns') {
<h3>
    <span class="LayerLine1">Current Issue ID:</span>
    <span class="LayerData1">{{glbl_issue_short_desc}}</span>
  </h3>
}
</div>

<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    <li [class.active]="activeTab === 0">
      <a (click)="switchTab(0)" style="cursor: pointer;" class="btn-sm">Schedule M2</a>
    </li>
    <li [class.active]="activeTab === 1">
      <a (click)="switchTab(1)" style="cursor: pointer;" class="btn-sm">Details</a>
    </li>
    <li [class.active]="activeTab === 2">
      <a (click)="switchTab(2)" style="cursor: pointer;" class="btn-sm">Audit</a>
    </li>
  </ul>

  <div class="tab-content">
    <form name="screenFrom" id="screenFrom" class="form-horizontal" novalidate>
      
      @if (saving) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      @if (saving) {
<h2 class="savingText">Saving...</h2>
}
      
      @if (loading) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      <!-- Main Schedule M2 Tab -->
      @if (tabName === 'ScheduleM2') {
<div>
        <div style="margin-left: 5px; margin-right: 5px; margin-bottom: 30px">
          @if (!loading && !saving) {
<div>
            <div style="padding-top: 0 !important;">
              <table style="width: 100%; border: 0px">
                <tbody>
                  <tr class="ScrHdrTbl">
                    <td>
                      <table class="InnerTblBG" style="width: 100%; border: 0px;">
                        <tbody>
                          <tr>
                            @if (scheduleM2Header?.FORM_NAME == 'F1120') {
<td class="BlackSmHdrBC">
                              Retained Earnings Reconciliation <span class="RedTxtBR">Increase (Decrease) To Taxable Income</span>
                            </td>
}
                            @if (scheduleM2Header?.FORM_NAME == '1065') {
<td class="BlackSmHdrBC">
                              Partner Capital Reconciliation <span class="RedTxtBR">Increase (Decrease) To Taxable Income</span>
                            </td>
}
                          </tr>
                        </tbody>
                      </table>

                      <table class="InnerTblBG" style="width: 100%; border: 0px;">
                        <tbody>
                          <tr>
                            <td class="BlackTxtBL">{{scheduleM2Header?.ATTRIB_DESCRIPTION}}</td>
                          </tr>
                        </tbody>
                      </table>

                      <div id="table_container">
                        <!-- TABLE 1 - Increases -->
                        <table style="width: 50%; border: 0px; float: left">
                          <tbody>
                            @for (row of scheduleM2Through4List; track $index) {

                              @if (row.IS_FORM_DISPLAY === 'Y') {
<tr class="table1">
                                <td>{{row.LINE_DISP}}</td>
                                <td>
                                  {{row.ATTRIB_DESCRIPTION}}
                                  @if (row.ATTRIB_SHORT_CODE == 'INC_FAS52' || row.ATTRIB_SHORT_CODE == 'INC_FAS115') {
<span>
                                    <i (click)="goToTab2(row.ACCT_REF_KEY, row.ATTRIB_DESCRIPTION, row.LINE_NO, row.ATTRIB_VALUE)"
                                       class="fa fa-info-circle"
                                       style="font-size: 24px; color: skyblue; cursor: pointer;"></i>
                                  </span>
}
                                </td>
                                @if (row.IS_EDITABLE_CELL == 'N' && row.DATA_TYPE != 'string') {
<td
                                    style="width: 183px; text-align: right; padding-right: 10px"
                                    [ngClass]="{'color-red': row.ATTRIB_VALUE < 0}">
                                  <span>{{formatNumber(row.ATTRIB_VALUE)}}</span>
                                </td>
}
                                @if (row.IS_EDITABLE_CELL == 'Y') {
<td style="width: 183px; text-align: right; padding-right: 10px">
                                  <div>
                                    @if (row.DATA_TYPE == 'number') {
<input
                                           class="form-control input-md numText"
                                           style="text-align: right"
                                           type="text"
                                           [(ngModel)]="row.ATTRIB_VALUE"
                                           [ngModelOptions]="{standalone: true}"
                                           [disabled]="row.is_editable"
                                           placeholder=""
                                           (blur)="adjustGainLoss()"
                                           (ngModelChange)="updateOtherIncreases(retainEarningsObj)">
}
                                    @if (row.DATA_TYPE == 'string') {
<input
                                           class="form-control input-md numText"
                                           maxlength="500"
                                           style="text-align: right"
                                           type="text"
                                           [(ngModel)]="row.ATTRIB_VALUE"
                                           [ngModelOptions]="{standalone: true}"
                                           [disabled]="row.is_editable"
                                           placeholder=""
                                           (blur)="adjustGainLoss()">
}
                                  </div>
                                </td>
}
                              </tr>
}
                            
}
                          </tbody>
                        </table>

                        <!-- TABLE 2 - Decreases -->
                        <table style="width: 50%; border: 0px">
                          <tbody>
                            @for (row of scheduleM2Through8List; track $index) {

                              @if (row.IS_FORM_DISPLAY === 'Y') {
<tr class="table1">
                                <td>{{row.LINE_DISP}}</td>
                                <td>
                                  {{row.ATTRIB_DESCRIPTION}}
                                  @if (row.ATTRIB_SHORT_CODE == 'DEC_FAS52' || row.ATTRIB_SHORT_CODE == 'DEC_FAS115') {
<span>
                                    <i (click)="goToTab2(row.ACCT_REF_KEY, row.ATTRIB_DESCRIPTION, row.LINE_NO, row.ATTRIB_VALUE)"
                                       class="fa fa-info-circle"
                                       style="font-size: 24px; color: skyblue; cursor: pointer;"></i>
                                  </span>
}
                                </td>
                                @if (row.IS_EDITABLE_CELL == 'N' && row.DATA_TYPE != 'string') {
<td
                                    style="width: 210px; text-align: right; padding-right: 40px"
                                    [ngClass]="{'color-red': row.ATTRIB_VALUE < 0}">
                                  <span>{{formatNumber(row.ATTRIB_VALUE)}}</span>
                                </td>
}
                                @if (row.IS_EDITABLE_CELL == 'Y') {
<td style="width: 210px; text-align: right; padding-right: 40px">
                                  <div>
                                    @if (row.DATA_TYPE == 'number') {
<input
                                           class="form-control input-md numText"
                                           style="text-align: right"
                                           type="text"
                                           [(ngModel)]="row.ATTRIB_VALUE"
                                           [ngModelOptions]="{standalone: true}"
                                           [disabled]="row.is_editable"
                                           placeholder=""
                                           (blur)="adjustGainLoss()"
                                           (ngModelChange)="updateOtherIncreases(retainEarningsObj)">
}
                                    @if (row.DATA_TYPE == 'string') {
<input
                                           class="form-control input-md numText"
                                           maxlength="500"
                                           style="text-align: right"
                                           type="text"
                                           [(ngModel)]="row.ATTRIB_VALUE"
                                           [ngModelOptions]="{standalone: true}"
                                           [disabled]="row.is_editable"
                                           placeholder=""
                                           (blur)="adjustGainLoss()">
}
                                  </div>
                                </td>
}
                                <!-- For CASH -->
                                @if (row.IS_EDITABLE_CELL == 'Y' && (row.DESCRIPTION == 'Cash' || row.ATTRIB_DESCRIPTION == 'Cash') && row.LINE_DISP != 5) {
<td
                                    style="width: 1px; text-align: right; padding-right: 10px">
                                  <!-- Confirmation message inline (similar to ng-really-message) -->
                                  <!-- Are you sure to override Distributions cash amount from {{row.ATTRIB_VALUE}} to {{scheduleM2HiddenList[0]?.ATTRIB_VALUE}}? -->
                                  @if (row.ATTRIB_VALUE != 0) {
<span>
                                    <button class="btn btn-info btn-sm" type="button" 
                                            (click)="updateDistributionsWithConfirm(row)">
                                      Apply
                                    </button>
                                  </span>
}
                                  @if (row.ATTRIB_VALUE == 0) {
<span>
                                    <button class="btn btn-info btn-sm" type="button" (click)="updateDistributions(row)">Apply</button>
                                  </span>
}
                                </td>
}
                              </tr>
}
                            
}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style="width: 50%; text-align: center; margin-top: 20px;">
                <tbody>
                  @for (row of scheduleM2OtherList; track $index) {
<tr>
                    @if (row.ROW_TYPE == 'BTH') {
<td>{{row.DESCRIPTION}}</td>
}
                  </tr>
}
                </tbody>
              </table>

              <table style="width: 50%; text-align: center; padding-top: 30px; margin-left: 475px">
                <tbody>
                  @for (row of scheduleM2OtherList; track $index) {

                    @if (row.IS_FORM_DISPLAY === 'Y') {
<tr style="width: 30%">
                      @if (row.ROW_TYPE != 'BTH' && row.ROW_TYPE != 'TH' && row.ATTRIB_SHORT_CODE != 'NBSP_1') {
<td
                          style="text-align: left">{{row.ATTRIB_DESCRIPTION}}</td>
}
                      @if (row.ROW_TYPE != 'BTH' && row.ROW_TYPE != 'TH' && row.ATTRIB_SHORT_CODE != 'NBSP_1') {
<td
                          [ngClass]="{'color-red': row.ATTRIB_VALUE < 0}"
                          style="text-align: right">{{formatNumber(row.ATTRIB_VALUE)}}</td>
}
                      @if (row.ROW_TYPE == 'TH' && row.ATTRIB_SHORT_CODE != 'NBSP_1') {
<td
                          class="TblSummBL"
                          style="font-weight: bold; text-align: left">{{row.ATTRIB_DESCRIPTION}}</td>
}
                      @if (row.ROW_TYPE == 'TH' && row.ATTRIB_SHORT_CODE != 'NBSP_1') {
<td
                          class="TblSummBL"
                          [ngClass]="{'color-red': row.ATTRIB_VALUE < 0}"
                          style="text-align: right">{{formatNumber(row.ATTRIB_VALUE)}}</td>
}
                      @if (row.ATTRIB_SHORT_CODE == 'NBSP_1') {
<td>&nbsp;</td>
}
                    </tr>
}
                  
}
                </tbody>
              </table>
            </div>
          </div>
}
        </div>
      </div>
}

      <!-- Details Tab -->
      @if (tabName === 'Details') {
<div>
        <div class="main_diag">
          <div class="diag-blocks">
            <div>
              <h2>Accounts</h2>
            </div>
            @if (showDiagLoader) {
<div class="viewFormLoader">
              <i class="fa fa-spinner fa-spin gt-refresh"></i>
              @if (clickedDiagTab) {
<p class="infoText">Please click an info icon in the Schedule M2 tab to see the details on this tab.</p>
}
            </div>
}
            @if (!showDiagLoader) {
<table class="mainTable">
              <thead>
                <tr>
                  <th class="first_heading">Line Number</th>
                  <th class="second_heading">Description</th>
                  <th class="amount">Amount(PY-CY)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="vertical-align: top">{{line_no}}</td>
                  <td>
                    <span (click)="toggleTotal = !toggleTotal" style="cursor: pointer;">
                      @if (!toggleTotal && parseValue(value) != 0) {
<span><i class="fa fa-plus-circle"></i></span>
}
                      @if (toggleTotal || parseValue(value) == 0) {
<span><i class="fa fa-minus-circle"></i></span>
}
                    </span> {{desc}}
                    @if (toggleTotal && parseValue(value) != 0) {
<div class="totalLines">
                      <table>
                        <thead>
                          <tr class="innerRow">
                            <th class="first_heading">Amount Type</th>
                            <th class="first_heading">Account</th>
                            <th>Description</th>
                            <th class="amount">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (row of systemAccts; track $index) {
<tr>
                            <td style="vertical-align: top">{{row.AMOUNT_TYPE}}</td>
                            <td style="vertical-align: top">{{row.SYS_ACCT}}</td>
                            <td>
                              <span (click)="row.TOGGLE = !row.TOGGLE" style="cursor: pointer;">
                                @if (!row.TOGGLE) {
<span><i class="fa fa-plus-circle"></i></span>
}
                                @if (row.TOGGLE) {
<span><i class="fa fa-minus-circle"></i></span>
}
                              </span> {{row.ACCT_DESC}}
                              @if (row.TOGGLE) {
<div class="localLines">
                                <table>
                                  <thead>
                                    <tr class="innerRow">
                                      <th class="first_heading">Account</th>
                                      <th>Description</th>
                                      <th class="amount">Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (row2 of localAccts; track $index) {
<tr>
                                      @if (row2.SYS_ACCT_KEY === row.SYS_ACCT_KEY && row2.AMOUNT_TYPE === row.AMOUNT_TYPE) {

                                        <td style="vertical-align: top">{{row2.LOCAL_ACCT}}</td>
                                        <td>{{row2.ACCT_DESC}}</td>
                                        <td style="text-align: right; vertical-align: top;">{{formatNumber(row2.AMT)}}</td>
                                      
}
                                    </tr>
}
                                  </tbody>
                                </table>
                              </div>
}
                            </td>
                            <td style="text-align: right; vertical-align: top;">{{formatNumber(row.AMT)}}</td>
                          </tr>
}
                        </tbody>
                      </table>
                    </div>
}
                  </td>
                  <td class="amount">{{formatNumber(value)}}</td>
                </tr>
              </tbody>
            </table>
}
          </div>
        </div>
      </div>
}

      <!-- Audit Tab -->
      @if (tabName === 'Audit') {
<div>
        <div class="form-horizontal">
          <div class="main-header">
            <div style="text-align: center" class="col-sm-4">
              <span>Transaction Number</span>
            </div>
            <div class="col-sm-3">
              <span>User</span>
            </div>
            <div class="col-sm-2">
              <span>Date</span>
            </div>
            <div class="col-sm-3">
              <span>View Transactions</span>
            </div>
          </div>
        </div>
        @if (showBatchLoader) {
<div class="viewFormLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!showBatchLoader && noRecords) {
<div>
          <h4>No records were found.</h4>
        </div>
}

        @if (!showBatchLoader && !noRecords) {

          @for (batchItem of batchList; track $index) {
<div class="audit-row">
            <div class="form-horizontal">
              <div style="text-align: center" class="col-sm-4">
                <span>{{batchItem.STAGE_KEY}}</span>
              </div>
              <div class="col-sm-3">
                <span>{{batchItem.USER_NAME}}</span>
              </div>
              <div class="col-sm-2">
                <span>{{batchItem.CR_DATE}}</span>
              </div>
              <div class="col-sm-3">
                <button type="button" class="btn btn-primary transaction-btn" (click)="showUploads(batchItem.STAGE_KEY)">View Transactions</button>
              </div>
            </div>
            @if (batchItem.TOGGLE) {
<div class="audit-table">
              @if (batchLoader) {
<div class="viewBatchLoader">
                <i class="fa fa-spinner fa-spin gt-refresh"></i>
              </div>
}
              @if (showBatchData) {
<table class="table table-bordered form-inline">
                <thead>
                  <tr class="audit-table-head">
                    <td class="audit-description">Description</td>
                    <td class="audit-amount">Amount</td>
                  </tr>
                </thead>
                <tbody>
                  @for (batchItemData of batchItemData; track $index) {
<tr>
                    <td class="audit-description">{{batchItemData.ATTRIB_DESCRIPTION}}</td>
                    @if (batchItemData.ATTRIB_NEW_VALUE && !batchItemData.IS_GREYED_OUT) {
<td class="audit-amount">
                      <div class="audit-inner-amount">{{batchItemData.ATTRIB_NEW_VALUE}}</div>
                    </td>
}
                    @if (batchItemData.ATTRIB_NEW_VALUE && batchItemData.IS_GREYED_OUT) {
<td class="audit-amount">
                      {{batchItemData.ATTRIB_NEW_VALUE}}
                    </td>
}
                  </tr>
}
                </tbody>
              </table>
}
            </div>
}
          </div>
}
        
}
      </div>
}
    </form>
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  @if (tabName === 'ScheduleM2') {
<button
          class="save-button"
          type="button"
          [disabled]="isSaveClicked || !isValidScenario"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  @if (tabName === 'ScheduleM2') {
<button
          class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
}
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

